import GATSBY_COMPILED_MDX from "/home/runner/work/developmentseed.github.com/developmentseed.github.com/content/blog/posts/2012/2012-11-26-week-in-dc-tech-november-26.mdx";
import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import {Link, graphql} from 'gatsby';
import get from 'lodash.get';
import {getImage} from 'gatsby-plugin-image';
import {Inpage, InpageHeader, InpageHeaderInner, InpageHeadline, InpageTitle, InpageSuptitle, InpageMetaDetails, InpageBody, InpageLead} from '$styles/inpage';
import Layout from '$components/layout';
import {AuthorAvatar, AuthorsAvatarsList} from '$components/author-avatar';
import Media from '$components/media';
import SectionLatestWork, {useLatestWork} from '$components/latest-work';
import InpageNavigation from '$components/inpage-nav';
import SectionRelated from '$components/section-related';
import {MDXProse} from '$components/mdx-prose';
import {prepareAuthorProperties} from '$utils/utils';
import Seo from '$components/seo';
import {InpageMDXWrapper} from '$styles/inpage';
const EstTime = (styled.dd)`
  &::before {
    content: '— ';
  }
`;
function BlogPostTemplate(props) {
  const {data, location, pageContext, children} = props;
  const {previous, next, id} = pageContext;
  const post = data.blogPost;
  const {date, timeToRead} = post;
  const {title, lead, authors, media, topics, related} = post.frontmatter;
  const nextPost = previous ? {
    url: `/blog/${previous.slug}`,
    linkTitle: 'Visit previous blog post',
    title: previous.frontmatter.title
  } : null;
  const prevPost = next ? {
    url: `/blog/${next.slug}`,
    linkTitle: 'Visit next blog post',
    title: next.frontmatter.title
  } : null;
  const coverImage = getImage(media?.cover?.url);
  const coverImageAttribution = get(media, 'cover.attribution');
  const authorsFields = prepareAuthorProperties(authors);
  const latestItems = useLatestWork({
    latestBlog: data.latestBlog,
    latestProject: data.latestProject,
    excludeId: id
  });
  return React.createElement(Layout, {
    location: location
  }, React.createElement(Inpage, null, React.createElement(InpageHeader, null, React.createElement(InpageHeaderInner, null, React.createElement(InpageHeadline, null, React.createElement(InpageTitle, null, title), React.createElement(InpageSuptitle, null, React.createElement(Link, {
    to: "/blog/",
    title: "View Blog page"
  }, "Blog")), React.createElement(InpageMetaDetails, null, React.createElement("dt", null, "Estimated"), React.createElement(EstTime, null, Math.max(timeToRead, 1).toFixed(), " min read")), authorsFields.length > 1 ? React.createElement(AuthorsAvatarsList, {
    authors: authorsFields,
    date: date
  }) : authorsFields.length === 1 ? React.createElement(AuthorAvatar, {
    url: `/team/${authorsFields[0].slug}`,
    name: authorsFields[0].name,
    image: authorsFields[0].avatar,
    date: date
  }) : React.createElement(AuthorAvatar, {
    date: date
  })), lead && React.createElement(InpageLead, null, React.createElement("p", null, lead)))), React.createElement(InpageBody, {
    isSoftPadded: !!coverImage
  }, coverImage && React.createElement(Media, {
    size: "cover",
    decoration: "top",
    image: coverImage,
    attribution: coverImageAttribution,
    alt: "Blog post cover image"
  }), React.createElement(InpageMDXWrapper, null, React.createElement(MDXProse, null, children)), !!related?.length && React.createElement(SectionRelated, {
    related: related
  }), React.createElement(InpageNavigation, {
    topics: topics,
    prevPost: prevPost,
    nextPost: nextPost
  }), React.createElement(SectionLatestWork, {
    items: latestItems
  }))));
}
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
BlogPostTemplate.propTypes = {
  data: T.object,
  location: T.object,
  pageContext: T.shape({
    id: T.string,
    next: T.object,
    previous: T.object
  }),
  children: T.node
};
export const pageQuery = graphql`
  query BlogPostById($id: String!) {
    blogPost: blog(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      timeToRead
      date
      frontmatter {
        title
        teaser
        topics
        lead
        media {
          ...CoverImageFluid
        }
        related {
          ...RelatedContent
        }
        authors {
          slug
          frontmatter {
            title
            media {
              avatar {
                url {
                  childImageSharp {
                    gatsbyImageData(layout: FIXED, width: 40, height: 40)
                  }
                }
              }
            }
          }
        }
      }
    }

    ...LatestWorkData
  }
`;
export const Head = ({data}) => {
  const {title, teaser, media} = data.blogPost.frontmatter;
  return React.createElement(Seo, {
    title: title,
    description: teaser,
    image: media?.cover?.url?.publicURL
  });
};
